export default {
  groupList: (state) => state.groupList.list,
  groupCount: (state) => state.groupList.count,
  sortText: (state) => state.sortText,
  sortType: (state) => state.sortType,
};
